import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { ApiResponseInterface, SelectOptionsInterface } from '../../interfaces/common.interface';
import { SelectSearchComponent } from '../select-search/select-search.component';
import { NavigationEnd, Router } from '@angular/router';
import { initFlowbite } from 'flowbite';
@Component({
  selector: 'app-country-search',
  templateUrl: '../select-search/select-search.component.html',
  styleUrls: ['../select-search/select-search.component.css'],
})


/**
 * Country search component
 */
export class CountrySearchComponent extends SelectSearchComponent implements OnInit, OnChanges {
  @Input() override enableError!: boolean;
  @Input() override label!: string;
  @Input() defaultSelected: any;
  @Output() override optionChangeEmitter = new EventEmitter<SelectOptionsInterface>();
  override searchKeyword!: string;
  @Input() override initialPlaceholder!: string;


  /**
   * @constructor
   */
  constructor(
    private commonService: CommonService,
    public override _eref: ElementRef,protected override router: Router

  ) {
    super(_eref,router);
  }

  /**
   * called initially
   */
  override ngOnInit(): void {
       this.router.events.subscribe((event) => {
          if (event instanceof NavigationEnd) {
           setTimeout(() => {  initFlowbite();})
          }
        });
    super.ngOnInit();
    this.items = [];
    this.filteredItems = [];
    this.placeholder = '';
    // this.initialPlaceholder = 'Select Your Country';
    this.placeholder = 'Search your Country here';
    this.showSearchBox = true;
    this.enableError = false;    
  }

  /**
   * called when changes occur
   *
   * @param {SimpleChanges} changes
   */
  ngOnChanges(changes: SimpleChanges): void {
    setTimeout(() => {
      this.checkCachedValue(changes?.defaultSelected?.currentValue);
    }, 1000);
  }

  /**
   * check for cached value
   *
   * @param {any} defaultValue
   */
  private checkCachedValue(defaultValue: any): void {
      if (!this.items?.length) {
        this.getCountryList(defaultValue);
      } else {
        super.onSelectPreProcess(defaultValue);
      }
  }

  /**
   * Country list formatter
   *
   * @param {any} defaultValue
   */
  private getCountryList(defaultValue?: any): void {
    const formattedCountryList: Array<SelectOptionsInterface> = [];
    this.loader = true;
    this.commonService.getCountries().subscribe({
      next: (response: ApiResponseInterface) => {
        this.loader = false;
        // Formatting country for select box
        response.data.forEach((item: any) => {
          formattedCountryList.push({ displayText: `${item.name}`, value: item.name, _id: item._id, id: item.id });
        });
        this.items = formattedCountryList;
        this.filteredItems = this.items;
        if (defaultValue) {
          super.onSelectPreProcess(defaultValue);
          this.optionChangeListener(this.selectedOption);
        }
      },
      error: () => {
        this.loader = false;
      }
    });
  }

  /**
   * listen for options changes
   *
   * @param {string} selectedCountry
   */
  public optionChangeListener(selectedCountry: SelectOptionsInterface): void {
    this.optionChangeEmitter.emit(selectedCountry);
  }

  /**
   * On select change
   *
   * @param {string} value
   */
  public override onSelectChange(value: string): void {
    super.onSelectPreProcess(value);
    this.optionChangeListener(this.selectedOption);
  }


}
